import { render, staticRenderFns } from "./windowsAdmin.vue?vue&type=template&id=0b02a236&scoped=true"
import script from "./windowsAdmin.vue?vue&type=script&lang=js"
export * from "./windowsAdmin.vue?vue&type=script&lang=js"
import style0 from "./windowsAdmin.vue?vue&type=style&index=0&id=0b02a236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b02a236",
  null
  
)

export default component.exports